import React, {useRef} from "react";
import {SearchContentProvider} from "./SearchContext";
import SearchPanel from "./SearchPanel";
import {PageHeader} from "antd";
import SearchResult from "./SearchResult";
import {useSelector} from "react-redux";

const MyQuestionsSearchView = (props) => {

    const searchPanelComp = useRef(null);
    const user = useSelector(state => state.auth?.user.user);

    return (
        <SearchContentProvider
            isGeneral={"undefined"}
        >
            <SearchPanel
                triggerSearch={() => {searchPanelComp.current.startSearch();}}
                showCatalogs={true}
                showGeneralQuestionSelection={false}
            />
            <PageHeader
                title="Suchergebnisse"
                id="pageHeader"
                subTitle="Alle Fragen auf welche die Suchparameter zutreffen"
            />
            <SearchResult
                ref={searchPanelComp}
                allowDeleteQuestions={true}
                editorList={[user.id]}
            />
        </SearchContentProvider>
    )
}

export default MyQuestionsSearchView;
